import NPSSurveyCard from './NPSSurveyCard';

const NPSSurveysCards = ({ npsSurveys, scores }) => {
  return (
    <>
      {npsSurveys.map((npsSurvey) => (
        <NPSSurveyCard key={npsSurvey.id} npsSurvey={npsSurvey} score={scores?.[npsSurvey.id]} />
      ))}
    </>
  );
};

export default NPSSurveysCards;
